import type { Agreement } from '@/api';

export const useAgreementPolicy = (model: Ref<Agreement | undefined> | undefined) => {
    const { company, permissions } = useCompany();
    const getPolicy = (model: Agreement | undefined) => {
        const isSender = company.value?.id === model?.sender_company_id;
        const isReceiver = company.value?.id === model?.receiver_company_id;

        const viewAny = permissions.value?.viewAgreements;
        const manageAny = permissions.value?.manageAgreements;
        const signAny = permissions.value?.signAgreements;

        return {
            view: viewAny,
            update: manageAny && isSender && model?.status === 'created',
            sign: signAny && isReceiver && model?.status === 'created',
            terminate:
                manageAny &&
                (isSender || model?.can_be_rejected) &&
                model?.status !== 'terminated' &&
                model?.status !== 'archived',
            isSender,
            isReceiver,
        } as const;
    };

    const policy = computed(() => getPolicy(model?.value));

    return { policy, getPolicy };
};
